import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import { Card, Grid, Typography } from "@mui/material";
import { uniqBy } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomUpload from "../../../../components/CustomUpload";
import CustomSelect from "../../../../components/Select/Select";
import { soapApi } from "../../../../redux/actions/api";
import {
  getClinicFacilities,
  getClinicStocksWoLoader,
  getLocations,
  getPetBillingByIdAllWoLoader,
  getServicesWoLoader,
} from "../../../../redux/reducers/clinicSlice";
import { hideLoader, showLoader } from "../../../../redux/reducers/loaderSlice";
import {
  createPrescriptionWoLoader,
  createProcedure,
  createProcedureWoLoader,
  deletePrescriptionItemByIdWoLoader,
  deleteProcedureByIdWoLoader,
  deleteProcedureDetailByIdWoLoader,
  getPetsCompliantSummaryWoLoader,
  updateNoteByAppointmentIdWoLoader,
  updatePrescriptionByIdWoLoader,
  updateProcedureByIdWoLoader,
} from "../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../util/AppColors";
import {
  frequncyCheckList,
  reasonIssueList,
  reasonList,
} from "../../../../util/arrayList";
import {
  mealTypes,
  pharmacyStatusDrop,
  routeList,
} from "../../../../util/dropList";
import {
  datePlusOneDay,
  getOnlyName,
  getProcedureDetails,
  getRightPackageUom,
} from "../../../../util/function";
import FilesWithCloseButton from "./FilesWithCloseButton";

const initProced = { consumList: [], adminList: [], presList: [] };
const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };
const delBtn = { color: AppColors.red, width: 20, height: 20 };
const edtBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
const initOpenObj = { consum: true, admin: true, pres: true };
const cardSty = {
  borderRadius: 3,
  padding: 1,
  borderTopColor: AppColors.appPrimary,
  marginLeft: 0.5,
  marginRight: 0.5,
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.25)",
};
const cardIcon = { width: 30, height: 30, color: AppColors.appPrimary };
const reqTxt = "This field is required";
const initPres = {
  name: null,
  dosage: "1",
  duration: "1",
  frequency: [],
  meal: "",
  customFrequency: false,
  route: routeList?.[0],
  plName: null,
};
const initFileValues = { modVsble: false, files: [], type: null };

const PetPharmacyProcedures = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [procedures, setProcedures] = useState([]);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const [procedValues, setProcedValues] = useState(initProced);
  const [changeWarnVsble, setChangeWarnVsble] = useState(false);
  const [notesModVsble, setNotesModVsble] = useState(false);
  const [notes, setNotes] = useState("");
  const [adminValues, setAdminValues] = useState({});
  const [presValues, setPresValues] = useState({});
  const [consumValues, setConsumValues] = useState({});
  const [admStatusVsble, setAdmStatusVsble] = useState(false);
  const [presStatusVsble, setPresStatusVsble] = useState(false);
  const [admUpdteModVsble, setAdmUpdteModVsble] = useState(false);
  const [conStatusVsble, setConStatusVsble] = useState(false);
  const [fileValues, setFileValues] = useState(initFileValues);
  const [objOpen, setObjOpen] = useState(initOpenObj);
  const [selectedItem, setSelectedItem] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const { services, clinicStocks, petBilling, locationList, facilities } =
    useSelector((state) => state?.clinic);
  const { appointment } = location.state || {};
  const clinicDet = useSelector((state) => state?.clinic?.details);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const appDet = reqDet?.appointment;
  const role = localStorage.getItem("role");

  useEffect(() => {
    dispatch(getServicesWoLoader());
    dispatch(getClinicStocksWoLoader());
    dispatch(
      getPetBillingByIdAllWoLoader({
        petId: appDet?.petId ?? appointment?.appoinment?.petId,
      })
    );
    dispatch(getLocations());
    dispatch(getClinicFacilities());
  }, []);

  useEffect(() => {
    const reqPrceds = [];
    const reqCons = [];
    const reqAdms = [];
    const reqPresList = [];
    reqDet?.procedures?.forEach((prcd, i) => {
      const reqServ = services?.data?.find(
        (ser) => ser?.serviceId === prcd?.serviceId
      );
      const vnts = getVarinatList(prcd?.serviceId);
      const reqVnt = vnts?.find(
        (vnt) =>
          vnt?.serviceId === prcd?.serviceId && vnt?.name === prcd?.serviceType
      );
      const reqObj = {
        service: {
          name: reqServ?.serviceName,
          value: reqServ?.serviceName,
          serviceId: reqServ?.serviceId,
          category: reqServ?.category,
          subCategory: reqServ?.subCategory,
          remarks: reqServ?.description,
          procedureId: prcd?.procedureId,
        },
        variant: reqVnt,
        procedureId: prcd?.procedureId,
        i,
      };
      reqPrceds.push(reqObj);
      prcd?.procedureDetails
        ?.filter(
          (det) =>
            !(
              det?.status === "true" ||
              det?.status === "false" ||
              det?.status === null
            ) ||
            det?.itemIssued === "true" ||
            det?.itemIssued === "false"
        )
        ?.forEach((det) => {
          const reqStock = clinicStocks?.data?.find(
            (stc) => stc?.stockId === det?.stockId
          );
          const reqBatc = reqStock?.stockBatch?.find(
            (bat) => bat?.batchId === det?.batchId
          );
          const comObj = {
            name:
              det?.name ?? reqStock?.productName ?? det?.procedureName ?? "",
            procedureName: det?.procedureName,
            stockId: det?.stockId,
            batchId: det?.batchId,
            quantity: det?.quantity,
            detailId: det?.detailId,
            active: det?.active,
            status:
              det?.status?.length > 0
                ? det?.status === "true" || det?.status === "false"
                : null,
            itemIssued:
              det?.itemIssued?.length > 0 ? det?.itemIssued === "true" : null,
            isRejected:
              det?.status === "rejected" || det?.itemIssued === "false",
            isRequested: det?.status === "requested",
            statusDrop:
              det?.status?.length > 0
                ? det?.status === "true"
                  ? pharmacyStatusDrop?.[0]
                  : pharmacyStatusDrop?.[1]
                : null,
            reason: det?.remarks?.length > 0 ? det?.remarks : null,
            estCost: det?.estimatedCost,
            delete: false,
            isEdit:
              det?.status === "true" || det?.status === "false"
                ? false
                : det?.itemIssued === "true" || det?.itemIssued === "false"
                ? false
                : true,
            deleteable: true,
            serviceId: prcd?.serviceId,
            variantId: reqVnt?.variantId,
            assignToProcedure: {
              name: reqServ?.serviceName,
              serviceId: prcd?.serviceId,
              value: reqServ?.serviceName,
              variantId: reqVnt?.variantId,
            },
            linkToProcedure: reqServ?.serviceName,
            batchNumber: {
              name: reqBatc?.batchNo ?? "Unknown",
              value: reqBatc?.batchId ?? null,
              batchId: reqBatc?.batchId ?? null,
              salesUom: reqBatc?.salesUom ?? null,
            },
          };
          if (det?.type === "Consumables") {
            reqCons.push(comObj);
          }
          if (det?.type === "Administered") {
            const reqAdmObj = {
              ...comObj,
              type: reqStock?.category,
              route: routeList?.find((rl) => rl?.name === det?.route),
              batchId: det?.batchId,
              duration: "1",
              vaccineType: det?.route,
              dosage: det?.dosage,
            };
            reqAdms.push(reqAdmObj);
          }
        });
    });
    reqDet?.prescription?.[0]?.prescriptionDetails?.forEach((li, i) => {
      const reqObj = {
        ...li,
        detailId: li?.id,
        name: null,
        dosage: li?.dosage,
        duration: li?.duration,
        frequency:
          li?.morning || li?.afternoon || li?.night
            ? [
                li?.morning && "morning",
                li?.afternoon && "afternoon",
                li?.night && "night",
              ]?.filter(Boolean)
            : li?.frequencyDuration?.length > 0
            ? li?.frequencyDuration
            : null,
        customFrequency:
          !li?.morning &&
          !li?.afternoon &&
          !li?.night &&
          li?.frequencyDuration?.length > 0,
        meal: li?.meal,
        plName: li?.name,
        i,
        type: li?.type,
        stockId: li?.stockId,
        qty: li?.quantity,
        itemIssued:
          li?.itemIssued?.length > 0 ? li?.itemIssued === "true" : null,
        itemIssuedStatus: li?.itemIssuedStatus,
        isEdit:
          li?.itemIssued === "true" || li?.itemIssued === "false"
            ? false
            : true,
      };
      reqPresList.push(reqObj);
    });
    setProcedures(reqPrceds);
    setProcedValues({
      ...procedValues,
      consumList:
        reqCons?.length > 0 ? reqCons?.map((cl, i) => ({ ...cl, i })) : [],
      adminList:
        reqAdms?.length > 0 ? reqAdms?.map((al, i) => ({ ...al, i })) : [],
      presList:
        reqPresList?.length > 0
          ? reqPresList?.map((pl, i) => ({ ...pl, i }))
          : [],
    });
  }, [reqDet?.procedures, reqDet?.prescription]);

  const onApiCall = () => {
    dispatch(getPetsCompliantSummaryWoLoader(appDet?.appointmentId));
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId
    );
    if (!reqStock) return [];
    const filteredBatches = reqStock?.stockBatch
      // ?.filter((btch) => btch?.billlable === "Y")
      ?.map((btch) => ({
        name: btch?.batchNo,
        value: btch?.batchNo,
        batchId: btch?.batchId,
        salesUom: btch?.salesUom,
        packageUom: btch?.packageUom,
      }));
    return filteredBatches;
  };

  const getBatch = (stockId, batchId = null, retStock = false) => {
    if (!stockId) return null;
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId
    );
    if (retStock) return reqStock;
    if (!batchId) return null;
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const getServiceList = () => {
    const reqServList = services?.data
      ?.filter((sl) => sl?.category !== "Diagnostics")
      ?.map((ser) => ({
        name: ser?.serviceName,
        value: ser?.serviceName,
        serviceId: ser?.serviceId,
        category: ser?.category,
        subCategory: ser?.subCategory,
        remarks: ser?.description,
      }));
    const procedureIds = new Set(procedures?.map((p) => p?.service?.serviceId));
    const reqList = reqServList?.filter(
      (srv) => !procedureIds.has(srv?.serviceId)
    );
    return reqList;
  };

  const onChange = (name, value, ind, vrntId) => {
    const reqPrcdres = procedures?.map((li) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "service") {
          reqObj.serviceId = value?.serviceId;
          const vrnts = getVarinatList(value?.serviceId);
          reqObj.variant = vrnts?.[0];
          reqObj.variantId = vrnts?.[0]?.variantId;
        }
        if (name === "variant") {
          reqObj.variantId = value?.variantId;
        }
        return reqObj;
      }
      return li;
    });
    setProcedures(reqPrcdres);
  };

  const getVarinatList = (serId) => {
    if (!serId) return [];
    const reqList = services?.data
      ?.find((ser) => ser?.serviceId === serId)
      ?.serviceVariants?.map((vnt) => ({
        name: vnt?.variantName,
        variantId: vnt?.variantId,
        servicePrice: vnt?.servicePrice,
        value: vnt?.variantName,
        serviceCharge: vnt?.serviceCharge,
        variantNumber: vnt?.variantNumber,
        serviceId: serId,
      }));
    return reqList ?? [];
  };

  const delProcedure = (ind) => {
    const reqServ = procedures?.find((li) => li?.i === ind)?.service;
    if (reqServ?.procedureId) {
      if (
        procedValues?.consumList
          ?.filter((li) => li?.serviceId === reqServ?.serviceId)
          ?.some((li) => typeof li?.status === "boolean") ||
        procedValues?.adminList
          ?.filter((li) => li?.serviceId === reqServ?.serviceId)
          ?.some((li) => typeof li?.status === "boolean")
      ) {
        setSelectedProcedure({
          type: "delete",
          index: ind,
          serviceId: reqServ?.serviceId,
          procedureId: reqServ?.procedureId ?? null,
        });
        return setChangeWarnVsble(true);
      }
      dispatch(deleteProcedureByIdWoLoader(reqServ?.procedureId)).then(
        (res) => {
          if (res?.payload) onApiCall();
        }
      );
    }
  };

  const addPreventive = (itm) => {
    const reqSer = services?.data?.find(
      (li) => li?.serviceId === itm?.serviceId
    );
    const reqVnt = reqSer?.serviceVariants?.find(
      (li) => li?.variantId === itm?.variantId
    );
    const data = {
      doneAt: moment(new Date(itm?.nextDueDate)).format("YYYY-MM-DD"),
      remarks: "",
      procedureDetails: [],
      serviceType: reqVnt?.variantName,
      isFromPreventive: true,
      procedureVariantId: reqVnt?.variantId ?? itm?.variantId,
      procedureName: itm?.linkToProcedure,
      serviceId: itm?.serviceId,
      category: reqSer?.category ?? "",
      subCategory: reqSer?.subCategory ?? "",
      petId: appDet?.petId,
      status: "Pending",
    };
    dispatch(createProcedure(data));
  };

  const onCloseFileMod = () => {
    setFileValues(initFileValues);
  };

  const getItemPrice = (stkId = null, batchId = null) => {
    let unitSellingPrice = 0;
    const reqStock = clinicStocks?.data?.find((stc) => stc?.stockId === stkId);
    if (reqStock) {
      if (batchId) {
        return (
          reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId)
            ?.unitSellingPrice ?? 0
        );
      }
      return reqStock?.stockBatch?.[0]?.unitSellingPrice;
    }
    return unitSellingPrice;
  };

  const addUpdateAdminItems = (obj) => {
    const reqProced = reqDet?.procedures?.find(
      (pl) => pl?.serviceId === obj?.serviceId
    );
    if (!reqProced?.procedureId) return;
    const reqObj = {
      detailId: obj?.detailId ?? null,
      stockId: obj?.stockId ?? null,
      batchId: obj?.batchId ?? obj?.batchNumber?.value ?? null,
      type: "Administered",
      quantity: Number(obj?.quantity),
      status: obj?.status,
      remarks: obj?.reason,
      estimatedCost: obj?.estCost,
      name: obj?.name,
      procedureName: obj?.name,
      dosage: obj?.dosage,
      route: obj?.route?.value ?? null,
      isDelete: false,
      serviceId: obj?.serviceId,
      itemIssued: obj?.itemIssued ?? null,
      itemIssuedStatus: obj?.itemIssuedStatus ?? null,
    };
    dispatch(
      updateProcedureByIdWoLoader({
        id: reqProced?.procedureId,
        data: {
          serviceCharge: reqProced?.serviceCharge,
          serviceType: reqProced?.serviceType,
          appointmentId: reqDet?.appointment?.appointmentId,
          procedureDetails: [reqObj],
        },
      })
    ).then((res) => {
      if (res?.payload) {
        onApiCall();
        onCloseFileMod();
      }
    });
  };

  const handleEditProcedure = (ind) => {
    const reqList = procedures?.map((li, i) => {
      if (i === ind) {
        return {
          ...li,
          editable: true,
          prevServId: li?.service?.serviceId,
          prevVarntId: li?.variant?.variantId,
          procedureId: li?.procedureId ?? li?.service?.procedureId ?? null,
        };
      }
      return li;
    });
    setProcedures(reqList);
  };

  const onAddNotes = () => {
    setNotes(appDet?.notes ?? "");
    setNotesModVsble(true);
  };

  const handleAddNewPres = () => {
    const reqList = [
      ...procedValues?.presList,
      { ...initPres, i: procedValues?.presList?.length, isEdit: true },
    ];
    setProcedValues({ ...procedValues, presList: reqList });
  };

  const getReqFacility = () => {
    return (
      facilities?.find((fac) => fac?.facilityId === appDet?.facilityId) ?? null
    );
  };

  const getRequiredBatch = (batchList) => {
    if (!batchList) return null;
    const primLocMat = batchList?.find(
      (bat) => bat?.locationId === getReqFacility()?.primaryStorage
    );
    if (primLocMat) return primLocMat;
    const secLocMat = batchList?.find(
      (bat) => bat?.locationId === getReqFacility()?.secondaryStorage
    );
    if (primLocMat) return secLocMat;
    if (role !== "ROLE_DOCTOR") return batchList?.[0];
    return {
      batchNo: "Unknown",
      batchId: null,
      name: "Unknown",
      value: null,
      subunits: null,
      quantity: null,
      locationId: null,
      locationName: "",
    };
  };

  const onChangeAdminValue = (name, value, ind, addObj) => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList?.map((li, i) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name" && addObj) {
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (!li?.dosage && addObj?.stockId) {
            const batchList = clinicStocks?.data?.find(
              (stc) => stc?.stockId === addObj?.stockId
            )?.stockBatch;
            const reqBatch =
              batchList?.length > 0
                ? getRequiredBatch(batchList) ?? null
                : null;
            if (reqBatch?.dosage?.length > 0) {
              reqObj.dosage = reqBatch?.dosage;

              const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
              const priceRatio =
                Number(reqBatch?.dosage ?? 0) / Number(reqPack?.[1]);
              const reqPrice =
                (Number(reqBatch?.unitSellingPrice) ?? 0) *
                Number(priceRatio ?? 0);
              reqObj.batchId = reqBatch?.batchId;
              reqObj.estCost = reqPrice;
            }
            reqObj.batchNumber = {
              name: reqBatch?.batchNo,
              value: reqBatch?.batchId,
            };
          }
          if (li?.dosage) {
            if (addObj?.stockId) {
              const stckBatches = clinicStocks?.data?.find(
                (stc) => stc?.stockId === addObj?.stockId
              )?.stockBatch;
              const reqBatch = stckBatches?.find(
                (bat) =>
                  bat?.batchId ===
                  (addObj?.batchId ??
                    reqObj?.batchNumber?.value ??
                    reqObj?.batchId)
              );
              const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
              const priceRatio = Number(li?.dosage ?? 0) / Number(reqPack?.[1]);
              const reqPrice =
                (Number(reqBatch?.unitSellingPrice) ?? 0) *
                Number(priceRatio ?? 0);
              reqObj.batchId = reqBatch?.batchId;
              reqObj.estCost = reqPrice;
              reqObj.batchNumber = {
                name: reqBatch?.batchNo,
                value: reqBatch?.batchId,
              };
            }
          }
          if (!reqObj?.detailId) {
            reqObj.status = null;
            reqObj.reason = "";
            addUpdateAdminItems(reqObj);
          }
        }
        if (name === "batchNumber") {
          const reqBatch = getBatch(li?.stockId, value?.value ?? li?.batchId);
          const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          const priceRatio = Number(li?.dosage ?? 0) / Number(reqPack?.[1]);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
          reqObj.estCost = value?.value ? reqPrice : 0;
        }
        if (name === "status") {
          if (value) {
            reqObj.reason = "Issued";
            reqObj.status = "issued";
            if (
              li?.type?.toLowerCase() === "flea & tick treatment" ||
              li?.type?.toLowerCase() === "vaccines" ||
              li?.type?.toLowerCase() === "deworming"
            ) {
              setAdminValues({
                ...li,
                status: "issued",
                reason: "Issued",
                statusDrop: value,
                nextDueDate: datePlusOneDay,
              });
              setAdmUpdteModVsble(true);
            } else {
              addUpdateAdminItems(reqObj);
            }
          } else {
            setAdminValues({ reason: reasonList?.[0]?.value, i: ind });
            setAdmStatusVsble(true);
          }
        }
        if (name === "itemIssued") {
          if (value) {
            reqObj.itemIssuedStatus = "";
            reqObj.status = "issued";
            reqObj.reason = "";
            addUpdateAdminItems(reqObj);
          } else {
            setAdminValues({
              itemIssuedStatus: reasonIssueList?.[0]?.value,
              i: ind,
            });
            setAdmStatusVsble(true);
          }
        }
        if (name === "dosage") {
          const reqBatch = getBatch(
            li?.stockId,
            li?.batchNumber?.value ?? li?.batchId
          );
          const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          const priceRatio = Number(value) / Number(reqPack?.[1]);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
          reqObj.estCost = reqPrice;
        }
        if (name === "linkToProcedure") {
          reqObj.serviceId = addObj?.serviceId;
          reqObj.variantId = addObj?.variantId;
        }
        return reqObj;
      }
      return li;
    });
    setProcedValues(reqObj);
  };

  const getBatches = (stkId = null) => {
    const reqStock = clinicStocks?.data?.find((stc) => stc?.stockId === stkId);
    const primaryLocationMatch = reqStock?.stockBatch?.filter(
      (bat) =>
        // bat?.billlable === "Y" &&
        bat?.locationId === getReqFacility()?.primaryStorage
    );
    const secondaryLocationMatch = reqStock?.stockBatch?.filter(
      (bat) =>
        // bat?.billlable === "Y" &&
        bat?.locationId === getReqFacility()?.secondaryStorage
    );
    const otherLocationMatch = reqStock?.stockBatch?.filter(
      (bat) =>
        // bat?.billlable === "Y" &&
        bat?.locationId !== getReqFacility()?.secondaryStorage &&
        bat?.locationId !== getReqFacility()?.primaryStorage
    );
    const reqList = [
      ...(primaryLocationMatch ?? []),
      ...(secondaryLocationMatch ?? []),
      ...(role === "ROLE_DOCTOR" ? [] : otherLocationMatch ?? []),
    ];
    return reqList?.length > 0
      ? reqList?.map((bat) => {
          const reqLocation = locationList?.find(
            (loc) => loc?.id === bat?.locationId
          );
          return {
            name: bat?.batchNo,
            value: bat?.batchId,
            subunits: bat?.subunits,
            quantity: bat?.quantity,
            locationId: bat?.locationId,
            locationName: reqLocation?.locationName ?? "",
          };
        })
      : [
          {
            name: "Unknown",
            value: null,
            subunits: null,
            quantity: null,
            locationId: null,
            locationName: "",
          },
        ];
  };

  const deletePresDetailById = (id) => {
    dispatch(deletePrescriptionItemByIdWoLoader(id)).then((res) => {
      if (res?.payload) {
        onApiCall();
        onCloseDelMod();
      }
    });
  };

  const deletePresByIndex = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.presList = procedValues?.presList
      ?.reduce((acc, item) => {
        if (item?.i === ind) {
          if (item?.detailId != null || item?.detailId !== undefined) {
            acc.push(item);
            setSelectedItem({ item: item, type: "presDetail" });
            setDelModVsble(true);
            // deletePresDetailById(item?.detailId);
          }
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      ?.map((cl, i) => ({ ...cl, i }));
    setProcedValues(reqObj);
  };

  const addUpdateConsumItems = (obj) => {
    if (obj?.serviceId) {
      const reqProced = reqDet?.procedures?.find(
        (pl) => pl?.serviceId === obj?.serviceId
      );
      if (!reqProced?.procedureId) return;
      const reqObj = {
        detailId: obj?.detailId ?? null,
        stockId: obj?.stockId ?? null,
        batchId: obj?.batchId ?? null,
        type: "Consumables",
        quantity: Number(obj?.quantity),
        status: obj?.status,
        remarks: obj?.reason,
        estimatedCost: obj?.estCost,
        name: obj?.name,
        procedureName: obj?.name,
        isDelete: false,
        serviceId: obj?.serviceId ?? null,
        itemIssued: obj?.itemIssued ?? null,
        itemIssuedStatus: obj?.itemIssuedStatus ?? null,
      };
      dispatch(
        updateProcedureByIdWoLoader({
          id: reqProced?.procedureId,
          data: {
            serviceCharge: reqProced?.serviceCharge,
            serviceType: reqProced?.serviceType,
            appointmentId: reqDet?.appointment?.appointmentId,
            procedureDetails: [reqObj],
          },
        })
      ).then((res) => {
        if (res?.payload) {
          onApiCall();
          onCloseFileMod();
        }
      });
    }
  };

  const onChangeConsumValue = (name, value, ind, addObj) => {
    const reqList = procedValues?.consumList?.map((li) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name" && addObj) {
          reqObj.stockId = addObj?.stockId ?? li?.stockId;
          reqObj.batchId = addObj?.batchId ?? li?.batchId;
          reqObj.serviceId = addObj?.serviceId ?? li?.serviceId;
          reqObj.category = addObj?.category ?? li?.category;
          if (addObj?.stockId ?? li?.stockId) {
            const reqBatch = addObj?.batchId
              ? getBatch(
                  addObj?.stockId ?? li?.stockId,
                  addObj?.batchId ?? li?.batchId
                )
              : clinicStocks?.data?.find(
                  (stc) => stc?.stockId === addObj?.stockId ?? li?.stockId
                )?.stockBatch?.[0];
            reqObj.batchId = reqBatch?.batchId;
            const reqCost =
              Number(reqBatch?.unitSellingPrice) * Number(li?.quantity ?? 1);
            reqObj.estCost = reqCost;
          }
        }
        if (name === "batchNumber") {
          const reqBatch = getBatch(li?.stockId, value?.value ?? li?.batchId);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) *
            Number(li?.quantity ?? 1);
          reqObj.estCost = value?.value ? reqPrice : 0;
        }
        if (name === "quantity") {
          const price = getItemPrice(li?.stockId ?? null, li?.batchId ?? null);
          reqObj.estCost = Number(price) * Number(value ?? 1);
        }
        if (name === "status") {
          if (value) {
            reqObj.reason = "";
            addUpdateConsumItems(reqObj);
          } else {
            setConsumValues({ reason: reasonList?.[0]?.value, i: ind });
            setConStatusVsble(true);
          }
        }
        if (name === "itemIssued") {
          if (value) {
            reqObj.itemIssuedStatus = "";
            reqObj.status = "issued";
            reqObj.reason = "";
            reqObj.batchId = li?.batchNumber?.value ?? li?.batchId;
            addUpdateConsumItems(reqObj);
          } else {
            setConsumValues({
              itemIssuedStatus: reasonIssueList?.[0]?.value,
              i: ind,
            });
            setConStatusVsble(true);
          }
        }
        if (name === "linkToProcedure") {
          reqObj.serviceId = addObj?.serviceId;
          reqObj.variantId = addObj?.variantId;
        }
        return reqObj;
      }
      return li;
    });
    setProcedValues({ ...procedValues, consumList: reqList });
  };

  const handleChangePresValue = (name, value, ind, addObj) => {
    const reqList = procedValues?.presList?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "plName" && addObj) {
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (addObj?.stockId) {
            const reqBatch = clinicStocks?.data?.find(
              (stc) => stc?.stockId === addObj?.stockId
            )?.stockBatch?.[0];
            reqObj.batchId = reqBatch?.batchId;
            reqObj.dosage = reqBatch?.dosage;
          }
        }
        if (name === "type") reqObj.name = null;
        if (addObj?.productId) {
          reqObj.productId = addObj?.productId;
        }
        if (name === "itemIssued") {
          if (value) {
            reqObj.itemIssuedStatus = "Completed";
            addUpdatePresItems(reqObj);
            // reqObj.isEdit = false;
          } else {
            setPresValues({
              itemIssuedStatus: reasonIssueList?.[0]?.value,
              i: ind,
            });
            setPresStatusVsble(true);
          }
        }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        return reqObj;
      }
      return pl;
    });
    setProcedValues({ ...procedValues, presList: reqList });
  };

  const handleObjOpen = (name, value) => {
    setObjOpen({ ...objOpen, [name]: value });
  };

  const onAddFiles = (type) => {
    setFileValues({ ...fileValues, modVsble: true, type });
  };

  const addNewAdminister = () => {
    const reqObj = { ...procedValues };
    const reqList = procedValues?.adminList;
    reqList.push({
      name: "",
      batchNumber: null,
      quantity: 1,
      dosage: "",
      route: null,
      reason: null,
      i: procedValues?.adminList?.length,
      deleteable: true,
      isEdit: true,
      estCost: 0,
      status: null,
      delete: false,
      serviceId: procedures?.[0]?.service?.serviceId ?? null,
      variantId: procedures?.[0]?.variant?.variantId ?? null,
      linkToProcedure: procedures?.[0]?.service?.name ?? null,
    });
    reqObj.adminList = reqList;
    setProcedValues(reqObj);
  };

  const getDropList = (li) => {
    const list = [
      {
        name: li?.name,
        value: li?.name,
        stockId: li?.stockId,
        batchId: li?.batchId,
      },
    ];
    if (li?.alternates?.length > 0) {
      li?.alternates?.forEach((al) => {
        list.push({
          name: al?.name,
          value: al?.name,
          stockId: al?.stockId,
          batchId: al?.batchId,
        });
      });
    }
    return uniqBy(list, "stockId");
  };

  const getList = (isPres = false) => {
    let reqList = [];
    if (isPres) {
      reqList = clinicStocks?.data?.filter((dta) => {
        return (
          dta?.active === "Y" &&
          dta?.billable &&
          // dta?.stockBatch?.some((bat) => bat?.billlable === "Y") &&
          (dta?.category?.toLowerCase() === "deworming" ||
            dta?.category?.toLowerCase() === "diet" ||
            dta?.category?.toLowerCase() === "flea & tick treatment" ||
            dta?.category?.toLowerCase() === "fluid therapy" ||
            dta?.category?.toLowerCase() === "grooming & hygiene care" ||
            dta?.category?.toLowerCase() === "medication" ||
            dta?.category?.toLowerCase() === "nutrition and supplements" ||
            dta?.category?.toLowerCase() === "other parasite treatment" ||
            dta?.category?.toLowerCase() === "vaccines")
        );
      });
    } else {
      reqList = clinicStocks?.data?.filter((dta) => {
        return (
          dta?.active === "Y" &&
          dta?.billable &&
          // dta?.stockBatch?.some((bat) => bat?.billlable === "Y") &&
          (dta?.category?.toLowerCase() === "general consumables" ||
            dta?.category?.toLowerCase() === "medical supplies" ||
            dta?.category?.toLowerCase() === "surgical supplies" ||
            dta?.category?.toLowerCase() === "lab consumables" ||
            dta?.category?.toLowerCase() === "lab supplies" ||
            dta?.category?.toLowerCase() === "cleaning supplies" ||
            dta?.category?.toLowerCase() === "grooming & hygiene care" ||
            dta?.category?.toLowerCase() === "fluid therapy" ||
            dta?.category?.toLowerCase() === "mortuary")
        );
      });
    }
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
    }));
  };

  const getPresList = () => {
    const reqList = clinicStocks?.data?.filter((dta) => {
      return (
        dta?.active === "Y" &&
        dta?.billable &&
        // dta?.stockBatch?.some((btch) => btch?.billlable === "Y") &&
        (dta?.category?.toLowerCase() === "medication" ||
          dta?.category?.toLowerCase() === "diet" ||
          dta?.category?.toLowerCase() === "nutrition and supplements" ||
          dta?.category?.toLowerCase() === "fluid therapy" ||
          dta?.category?.toLowerCase() === "other parasite treatment" ||
          dta?.category?.toLowerCase() === "deworming" ||
          dta?.category?.toLowerCase() === "flea & tick treatment" ||
          dta?.category?.toLowerCase() === "grooming & hygiene care")
      );
    });
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
    }));
  };

  const deleteMultipleDetailIds = (ids = []) => {
    ids?.forEach((id) => {
      dispatch(deleteProcedureDetailByIdWoLoader(id));
    });
  };

  const createUpdateProcedure = (prcd) => {
    if (
      !(prcd?.serviceId ?? prcd?.service?.serviceId) ||
      !(prcd?.variantId ?? prcd?.variant?.variantId)
    ) {
      return;
    }
    if (!prcd?.service?.procedureId && !prcd?.prevServId) {
      const procedureDetails = getProcedureDetails(
        prcd?.serviceId ?? prcd?.service?.serviceId,
        prcd?.variantId ?? prcd?.variant?.variantId,
        prcd?.service?.name,
        services?.data ?? [],
        clinicStocks?.data ?? [],
        clinicDet?.pharmacyTaxId
      )?.procedureDetails;
      if (
        getProcedureDetails(
          prcd?.serviceId ?? prcd?.service?.serviceId,
          prcd?.variantId ?? prcd?.variant?.variantId,
          prcd?.service?.name,
          services?.data ?? [],
          clinicStocks?.data ?? [],
          clinicDet?.pharmacyTaxId
        )?.prescriptions?.length > 0
      ) {
        const data = {
          status: "Pending",
          remark: "",
          prescription: getProcedureDetails(
            prcd?.serviceId ?? prcd?.service?.serviceId,
            prcd?.variantId ?? prcd?.variant?.variantId,
            prcd?.service?.name,
            services?.data ?? [],
            clinicStocks?.data ?? [],
            clinicDet?.pharmacyTaxId
          )?.prescriptions,
          issue: "",
        };
        if (reqDet?.prescription?.[0]?.prescriptionId) {
          dispatch(
            updatePrescriptionByIdWoLoader({
              prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
              data,
            })
          );
        } else {
          dispatch(
            createPrescriptionWoLoader({
              appointmentId: appDet?.appointmentId,
              data,
            })
          );
        }
      }

      const data = {
        procedureName: prcd?.service?.name,
        serviceId: prcd?.service?.serviceId,
        category: prcd?.service?.category,
        subCategory: prcd?.service?.subCategory,
        remarks: prcd?.service?.remarks,
        doneAt: moment(new Date()).format("YYYY-MM-DD"),
        status: "Pending",
        petId: appDet?.petId,
        appointmentId: appDet?.appointmentId,
        serviceCharge: prcd?.variant?.serviceCharge,
        serviceType: getOnlyName(prcd?.variant?.name),
        procedureDetails,
      };
      dispatch(createProcedureWoLoader(data)).then((res) => {
        if (res?.payload) onApiCall();
      });
    } else {
      if (
        procedValues?.consumList?.some(
          (cl) => typeof cl?.status === "boolean"
        ) ||
        procedValues?.adminList?.some((cl) => typeof cl?.status === "boolean")
      ) {
        setSelectedProcedure({ ...prcd, type: "variantChange" });
        return setChangeWarnVsble(true);
      } else {
        if (prcd?.service?.serviceId === prcd?.prevServId) {
          const prevCosumIds = procedValues?.consumList
            ?.filter(
              (cl) =>
                cl?.serviceId === prcd?.prevServId &&
                cl?.variantId === prcd?.prevVarntId
            )
            ?.map((cl) => {
              return cl?.detailId;
            });
          const prevAdmIds = procedValues?.adminList
            ?.filter(
              (al) =>
                al?.serviceId === prcd?.prevServId &&
                al?.variantId === prcd?.prevVarntId
            )
            ?.map((al) => {
              return al?.detailId;
            });
          // for deleting the prev
          deleteMultipleDetailIds([
            ...(prevCosumIds ?? []),
            ...(prevAdmIds ?? []),
          ]);
          const procedureDetails = getProcedureDetails(
            prcd?.serviceId ?? prcd?.service?.serviceId,
            prcd?.variantId ?? prcd?.variant?.variantId,
            prcd?.service?.name,
            services?.data ?? [],
            clinicStocks?.data ?? [],
            clinicDet?.pharmacyTaxId
          )?.procedureDetails;
          if (
            getProcedureDetails(
              prcd?.serviceId ?? prcd?.service?.serviceId,
              prcd?.variantId ?? prcd?.variant?.variantId,
              prcd?.service?.name,
              services?.data ?? [],
              clinicStocks?.data ?? [],
              clinicDet?.pharmacyTaxId
            )?.prescriptions?.length > 0
          ) {
            const data = {
              status: "Pending",
              remark: "",
              prescription: getProcedureDetails(
                prcd?.serviceId ?? prcd?.service?.serviceId,
                prcd?.variantId ?? prcd?.variant?.variantId,
                prcd?.service?.name,
                services?.data ?? [],
                clinicStocks?.data ?? [],
                clinicDet?.pharmacyTaxId
              )?.prescriptions,
              issue: "",
            };
            if (reqDet?.prescription?.[0]?.prescriptionId) {
              dispatch(
                updatePrescriptionByIdWoLoader({
                  prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
                  data,
                })
              );
            } else {
              dispatch(
                createPrescriptionWoLoader({
                  appointmentId: appDet?.appointmentId,
                  data,
                })
              );
            }
          }
          const data = {
            procedureName: prcd?.service?.name,
            serviceId: prcd?.service?.serviceId,
            category: prcd?.service?.category,
            subCategory: prcd?.service?.subCategory,
            remarks: prcd?.service?.remarks,
            doneAt: moment(new Date()).format("YYYY-MM-DD"),
            status: "Pending",
            petId: appDet?.petId,
            appointmentId: appDet?.appointmentId,
            serviceCharge: prcd?.variant?.serviceCharge,
            serviceType: getOnlyName(prcd?.variant?.name),
            procedureDetails,
          };
          dispatch(
            updateProcedureByIdWoLoader({
              id: prcd?.service?.procedureId,
              data,
            })
          ).then((res) => {
            if (res?.payload) onApiCall();
          });
        } else {
          if (prcd?.procedureId) {
            dispatch(deleteProcedureByIdWoLoader(prcd?.procedureId));
          }
          const procedureDetails = getProcedureDetails(
            prcd?.serviceId ?? prcd?.service?.serviceId,
            prcd?.variantId ?? prcd?.variant?.variantId,
            prcd?.service?.name,
            services?.data ?? [],
            clinicStocks?.data ?? [],
            clinicDet?.pharmacyTaxId
          ).procedureDetails;
          if (
            getProcedureDetails(
              prcd?.serviceId ?? prcd?.service?.serviceId,
              prcd?.variantId ?? prcd?.variant?.variantId,
              prcd?.service?.name,
              services?.data ?? [],
              clinicStocks?.data ?? [],
              clinicDet?.pharmacyTaxId
            )?.prescriptions?.length > 0
          ) {
            const data = {
              status: "Pending",
              remark: "",
              prescription: getProcedureDetails(
                prcd?.serviceId ?? prcd?.service?.serviceId,
                prcd?.variantId ?? prcd?.variant?.variantId,
                prcd?.service?.name,
                services?.data ?? [],
                clinicStocks?.data ?? [],
                clinicDet?.pharmacyTaxId
              )?.prescriptions,
              issue: "",
            };
            if (reqDet?.prescription?.[0]?.prescriptionId) {
              dispatch(
                updatePrescriptionByIdWoLoader({
                  prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
                  data,
                })
              );
            } else {
              dispatch(
                createPrescriptionWoLoader({
                  appointmentId: appDet?.appointmentId,
                  data,
                })
              );
            }
          }
          const data = {
            procedureName: prcd?.service?.name,
            serviceId: prcd?.service?.serviceId,
            category: prcd?.service?.category,
            subCategory: prcd?.service?.subCategory,
            remarks: prcd?.service?.remarks,
            doneAt: moment(new Date()).format("YYYY-MM-DD"),
            status: "Pending",
            petId: appDet?.petId,
            appointmentId: appDet?.appointmentId,
            serviceCharge: prcd?.variant?.serviceCharge,
            serviceType: getOnlyName(prcd?.variant?.name),
            procedureDetails,
          };
          dispatch(createProcedureWoLoader(data)).then((res) => {
            if (res?.payload) onApiCall();
          });
        }
      }
    }
  };

  const deleteProcedureDetailById = (id) => {
    dispatch(deleteProcedureDetailByIdWoLoader(id)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        onApiCall();
      }
    });
  };

  const handleConsumDelete = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.consumList = procedValues?.consumList
      ?.reduce((acc, item) => {
        if (item?.i === ind) {
          if (item?.detailId != null || item?.detailId !== undefined) {
            acc.push(item);
            setSelectedItem({ item: item, type: "procedureDetail" });
            setDelModVsble(true);
            // deleteProcedureDetailById(item?.detailId);
          }
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      ?.map((cl, i) => ({ ...cl, i }));
    setProcedValues(reqObj);
  };

  const getProcedureListAsDrop = () => {
    if (procedures?.length === 0 || !procedures) return [];
    const reqProcedures = procedures
      ?.filter?.((li) => li?.service?.serviceId && li?.variant?.variantId)
      ?.map((prcd) => {
        return {
          name: prcd?.service?.name,
          value: prcd?.service?.name,
          serviceId: prcd?.service?.serviceId,
          varinatName: prcd?.variant?.name,
          variantId: prcd?.variant?.variantId,
        };
      });
    return reqProcedures;
  };

  const addProcedure = () => {
    const reqList = [...procedures];
    reqList.push({
      i: procedures?.length,
      serviceId: procedures?.[0]?.service?.serviceId ?? null,
      editable: true,
    });
    setProcedures(reqList);
  };

  const addNewConsumable = () => {
    const reqObj = { ...procedValues };
    const reqList = procedValues?.consumList;
    reqList.push({
      name: "",
      quantity: 1,
      reason: null,
      i: procedValues?.consumList?.length,
      deleteable: true,
      isEdit: true,
      estCost: 0,
      status: null,
      delete: false,
      serviceId: procedures?.[0]?.service?.serviceId ?? null,
      variantId: procedures?.[0]?.variant?.variantId ?? null,
      linkToProcedure: procedures?.[0]?.service?.name ?? null,
    });
    reqObj.consumList = reqList;
    setProcedValues(reqObj);
  };

  const handleConsumEdit = (ind) => {
    const reqObj = { ...procedValues };
    const reqList = procedValues?.consumList?.map((li) => {
      if (li?.i === ind) {
        return { ...li, isEdit: true, status: null };
      }
      return li;
    });
    reqObj.consumList = reqList;
    setProcedValues(reqObj);
  };

  const handleAdminDelete = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList
      ?.reduce((acc, item) => {
        if (item?.i === ind) {
          if (item?.detailId != null || item?.detailId !== undefined) {
            deleteProcedureDetailById(item?.detailId);
          }
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      ?.map((cl, i) => ({ ...cl, i }));
    setProcedValues(reqObj);
  };

  const handleAdminEdit = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList?.map((li) => {
      if (li?.i === ind) {
        setAdminValues({
          ...li,
          itemIssued:
            typeof li?.itemIssued === "boolean" ? li?.itemIssued : false,
          itemIssuedStatus: li?.itemIssuedStatus ?? reasonIssueList?.[0]?.value,
        });
        setAdmUpdteModVsble(true);
        return li;
      }
      return li;
    });
    setProcedValues(reqObj);
  };

  const addUpdatePresItems = (pre) => {
    if (
      pre?.plName === "" ||
      pre?.plName === null ||
      pre?.plName === undefined
    ) {
      return;
    }
    const selStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === pre?.stockId
    );
    const reqObj = {
      administered: false,
      type: pre?.type ?? null,
      stockId: pre?.stockId,
      batchId: selStock?.stockBatch?.[0]?.batchId ?? null,
      name: pre?.plName,
      dosage: pre?.dosage,
      duration: pre?.duration,
      meal: pre?.meal,
      quantity: typeof pre?.qty === "undefined" ? 1 : Number(pre?.qty),
      subUnit: "Unit",
      morning:
        (pre?.frequency?.includes("morning") &&
          !pre?.frequency?.includes("Custom")) ??
        false,
      afternoon:
        (pre?.frequency?.includes("afternoon") &&
          !pre?.frequency?.includes("Custom")) ??
        false,
      night:
        (pre?.frequency?.includes("night") &&
          !pre?.frequency?.includes("Custom")) ??
        false,
      adminChargeAmount: 0,
      adminCharge: "N",
      percentage: false,
      delete: false,
      discontinued: "N",
      detailId: pre?.detailId ?? null,
      itemIssued: pre?.itemIssued ?? null,
      itemIssuedStatus: pre?.itemIssuedStatus ?? null,
    };
    const btchDet = selStock?.stockBatch?.[0];
    const taxPercent =
      clinicDet?.pharmacyTaxId?.length > 0
        ? (btchDet?.cgst ? Number(btchDet?.cgst) : 0) +
          (btchDet?.sgst ? Number(btchDet?.sgst) : 0)
        : 0;
    const reqPercent = 100 + Number(taxPercent);
    const unitPrice =
      (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) /
      (reqPercent / 100);
    const taxValue =
      Number(
        (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) -
          Number(unitPrice)
      ) ?? 0;
    reqObj.price = unitPrice ?? 0;
    reqObj.mrpPrice = btchDet?.unitSellingPrice
      ? Number(btchDet?.unitSellingPrice)
      : 0;
    reqObj.mrpDiscount = 0;
    // (Number(
    //   btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0
    // ) /
    //   100) *
    // Number(taxPercent);
    reqObj.tax =
      Number(taxValue) * Number(typeof pre?.qty === "undefined" ? 1 : pre?.qty);
    reqObj.total =
      (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) *
        Number(typeof pre?.qty === "undefined" ? 1 : pre?.qty) ?? 0;
    if (typeof pre?.frequency === "string") {
      reqObj.frequencyDuration = pre?.frequency;
    }
    if (pre?.productId) reqObj.productId = pre?.productId;
    if (pre?.serviceId) reqObj.serviceId = pre?.serviceId;
    const data = {
      status: "Pending",
      remark: "",
      prescription: [reqObj],
      issue: "",
    };
    if (reqDet?.prescription?.[0]?.prescriptionId) {
      dispatch(
        updatePrescriptionByIdWoLoader({
          prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
          data,
        })
      ).then((res) => {
        if (res?.payload) {
          onApiCall();
        }
      });
    } else {
      dispatch(
        createPrescriptionWoLoader({
          appointmentId: appDet?.appointmentId,
          data,
        })
      ).then((res) => {
        if (res?.payload) {
          onApiCall();
        }
      });
    }
  };

  const handleEditPresItem = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.presList = procedValues?.presList?.map((pl, i) => {
      if (pl?.i === ind) return { ...pl, isEdit: true };
      return pl;
    }, []);
    setProcedValues(reqObj);
  };

  const onCloseConMod = () => {
    setConStatusVsble(false);
    setConsumValues({});
  };

  const onCloseAdmUpdteMod = () => {
    setAdmUpdteModVsble(false);
    setAdminValues({});
  };

  const onChangeAdminStatusValue = (name, value) => {
    setAdminValues({ ...adminValues, [name]: value });
  };

  const onChangeConStatusValue = (name, value) => {
    setConsumValues({ ...consumValues, [name]: value });
  };

  const onChangePresStatusValue = (name, value) => {
    setPresValues({ ...presValues, [name]: value });
  };

  const handleSaveConsumStatus = () => {
    const reqObj = { ...procedValues };
    reqObj.consumList = procedValues?.consumList?.map((li, i) => {
      if (li?.i === consumValues?.i) {
        const reqObj = {
          ...li,
          itemIssuedStatus: consumValues?.itemIssuedStatus,
          // reason: consumValues?.reason
          // status: false,
          itemIssued: false,
          status: "rejected",
          reason: consumValues?.itemIssuedStatus,
        };
        addUpdateConsumItems(reqObj);
        return reqObj;
      }
      return li;
    });
    setProcedValues(reqObj);
    onCloseConMod();
  };

  const handleSaveAdminStatus = () => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList?.map((li, i) => {
      if (li?.i === adminValues?.i) {
        const reqObj = {
          ...li,
          status: "rejected",
          reason: adminValues?.itemIssuedStatus,
          itemIssuedStatus: adminValues?.itemIssuedStatus,
          itemIssued: false,
          nextDosage: adminValues?.nextDosage,
          nextDueDate: adminValues?.nextDueDate,
        };
        addUpdateAdminItems(reqObj);
        return reqObj;
      }
      return li;
    });
    setProcedValues(reqObj);
    onCloseAdmMod();
  };

  const handleSavePresStatus = () => {
    const reqObj = { ...procedValues };
    reqObj.presList = procedValues?.presList?.map((li, i) => {
      if (li?.i === presValues?.i) {
        const reqObj = {
          ...li,
          itemIssuedStatus: presValues?.itemIssuedStatus,
          itemIssued: false,
        };
        addUpdatePresItems(reqObj);
        return reqObj;
      }
      return li;
    });
    setProcedValues(reqObj);
    onClosePresMod();
  };

  const onCloseAdmMod = () => {
    setAdmStatusVsble(false);
    setAdminValues({});
  };

  const onClosePresMod = () => {
    setPresStatusVsble(false);
    setPresValues({});
  };

  const onCloseNoteMod = () => {
    setNotesModVsble(false);
    setNotes("");
  };

  const onSaveNotes = () => {
    dispatch(
      updateNoteByAppointmentIdWoLoader({
        id: appDet?.appointmentId,
        note: notes,
        remarks: appDet?.remarks,
      })
    ).then((res) => {
      if (res?.payload) {
        onApiCall();
        onCloseNoteMod();
      }
    });
  };

  const onSaveAdminValues = () => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList?.map((li, i) => {
      if (li?.i === adminValues?.i) {
        addUpdateAdminItems({
          ...adminValues,
          status: adminValues?.itemIssued ? "issued" : "rejected",
          reason: adminValues?.itemIssued ? "" : adminValues?.itemIssuedStatus,
          itemIssued: adminValues?.itemIssued ? true : false,
          itemIssuedStatus: adminValues?.itemIssued
            ? ""
            : adminValues?.itemIssuedStatus,
        });
        return { ...adminValues, isEdit: false };
      }
      return li;
    });
    setProcedValues(reqObj);
    onCloseAdmUpdteMod();
  };

  const onChangeAdminModValue = (name, value, addObj) => {
    const reqObj = { ...adminValues, [name]: value };
    if (name === "name" && addObj) {
      reqObj.type = addObj?.type;
      reqObj.stockId = addObj?.stockId;
      if (!adminValues?.dosage && addObj?.stockId) {
        const reqBatch = clinicStocks?.data?.find(
          (stc) => stc?.stockId === addObj?.stockId
        )?.stockBatch?.[0];
        reqObj.batchNumber = {
          name: reqBatch?.batchNo,
          value: reqBatch?.batchId,
        };
      }
      if (adminValues?.dosage) {
        if (addObj?.stockId) {
          const reqBatch = clinicStocks?.data?.find(
            (stc) => stc?.stockId === addObj?.stockId
          )?.stockBatch?.[0];
          const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          const priceRatio =
            Number(adminValues?.dosage ?? 0) / Number(reqPack?.[1]);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
          reqObj.batchId = reqBatch?.batchId;
          reqObj.estCost = reqPrice;
          reqObj.batchNumber = {
            name: reqBatch?.batchNo,
            value: reqBatch?.batchId,
          };
        }
      }
    }
    if (name === "batchNumber") {
      const reqBatch = getBatch(
        adminValues?.stockId,
        value?.value ?? adminValues?.batchId
      );
      const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
      const priceRatio =
        Number(adminValues?.dosage ?? 0) / Number(reqPack?.[1]);
      const reqPrice =
        (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
      reqObj.estCost = value?.value ? reqPrice : 0;
    }
    if (name === "status") {
      if (value) {
        reqObj.reason = "Completed";
      } else {
        reqObj.reason = reasonList?.[0]?.value;
      }
    }
    if (name === "statusDrop") {
      reqObj.status = value;
      if (value) {
        reqObj.reason = "";
      } else {
        reqObj.reason = reasonList?.[0]?.value;
      }
    }
    if (name === "itemIssued") {
      reqObj.itemIssuedStatus = value;
      if (value) {
        reqObj.itemIssuedStatus = "";
      } else {
        reqObj.itemIssuedStatus = reasonList?.[0]?.value;
      }
    }
    if (name === "dosage") {
      const reqBatch = getBatch(
        adminValues?.stockId,
        adminValues?.batchNumber?.value ?? adminValues?.batchId
      );
      const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
      const priceRatio = Number(value) / Number(reqPack?.[1]);
      const reqPrice =
        (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
      reqObj.estCost = reqPrice;
    }
    if (name === "linkToProcedure") {
      reqObj.serviceId = addObj?.serviceId;
      reqObj.variantId = addObj?.variantId;
    }
    setAdminValues(reqObj);
  };

  const handleAdmImageRemove = (ind) => {
    const reqFiles = (adminValues?.files ?? [])?.filter((fl, i) => i !== ind);
    setAdminValues({ ...adminValues, files: reqFiles });
  };

  const onUploadAdmFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists =
      adminValues?.files?.length > 0 ? [...adminValues?.files] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [...fileLists, { file: file, previewUrl: reader.result }];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles)
      .then(() => setAdminValues({ ...adminValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onFilesApiCall = async () => {
    if (fileValues?.files?.length === 0 || !fileValues?.files) return;
    dispatch(showLoader());
    const formData = new FormData();
    fileValues?.files?.forEach((file) => {
      formData.append("files", file?.file);
    });
    const res = await soapApi.post("/vaccination", formData);
    if (res?.status === 200) {
      const reqStock = clinicStocks?.data?.filter(
        (li) =>
          li?.tradeName?.toLowerCase() ===
            (res?.data?.TradeName || "").toLowerCase() &&
          li?.stockBatch?.some(
            (bat) =>
              bat?.batchNo?.toLowerCase() ===
              (res?.data?.BatchNumber || "").toLowerCase()
          )
      );
      const reqBatch = reqStock?.stockBatch?.find(
        (bat) =>
          bat?.batchNo?.toLowerCase() === res?.data?.BatchNumber?.toLowerCase()
      );
      const reqObj = {
        name: res?.data?.Name ?? res?.data?.TradeName,
        quantity: 1,
        reason: null,
        deleteable: true,
        isEdit: true,
        estCost: reqStock?.unitSellingPrice ?? 0,
        status: null,
        delete: false,
        serviceId: procedures?.[0]?.service?.serviceId ?? null,
        variantId: procedures?.[0]?.variant?.variantId ?? null,
        linkToProcedure: procedures?.[0]?.service?.name ?? null,
        stockId: reqStock?.stockId ?? null,
        batchId: reqBatch?.batchId ?? null,
        detailId: null,
        dosage: "1",
        route: null,
        isDelete: false,
      };
      if (fileValues?.type === "consumables") {
        addUpdateConsumItems(reqObj);
      }
      if (fileValues?.type === "administer") {
        addUpdateAdminItems(reqObj);
      }
      dispatch(hideLoader());
    } else {
      dispatch(hideLoader());
    }
  };

  const handleRemoveFile = (ind) => {
    const reqFiles = (fileValues?.files ?? [])
      ?.filter((fl, i) => i !== ind)
      ?.map((li, i) => ({ ...li, i }));
    setFileValues({ ...fileValues, files: reqFiles });
  };

  const onUploadFiles = (e) => {
    const fileList = e?.target?.files;
    let fileLists = fileValues?.files?.length > 0 ? [...fileValues?.files] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [...fileLists, { file: file, previewUrl: reader.result }];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles)
      .then(() => setFileValues({ ...fileValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onCloseChangeWarnMod = () => {
    setChangeWarnVsble(false);
    setSelectedProcedure(null);
  };

  const onConfirmChangeWarn = () => {
    let reqData = {};
    if (selectedProcedure?.type === "delete") {
      if (selectedProcedure?.procedureId) {
        dispatch(
          deleteProcedureByIdWoLoader(selectedProcedure?.procedureId)
        ).then((res) => {
          if (res?.payload) {
            onApiCall();
            onCloseChangeWarnMod();
            return;
          }
        });
      }
      reqData.consumList = procedValues?.consumList
        ?.reduce((acc, item) => {
          if (item?.serviceId === selectedProcedure?.serviceId) {
            if (item?.detailId != null || item?.detailId !== undefined) {
              acc.push({ ...item, isDelete: true });
            }
          } else {
            acc.push(item);
          }
          return acc;
        }, [])
        ?.map((cl, i) => ({ ...cl, i }));
      reqData.adminList = procedValues?.adminList
        ?.reduce((acc, item) => {
          if (item?.serviceId === selectedProcedure?.serviceId) {
            if (item?.detailId != null || item?.detailId !== undefined) {
              acc.push({ ...item, isDelete: true });
            }
          } else {
            acc.push(item);
          }
          return acc;
        }, [])
        ?.map((al, i) => ({ ...al, i }));
    } else {
      if (
        selectedProcedure?.service?.serviceId === selectedProcedure?.prevServId
      ) {
        const prevCosumIds = procedValues?.consumList
          ?.filter(
            (cl) =>
              cl?.serviceId === selectedProcedure?.prevServId &&
              cl?.variantId === selectedProcedure?.prevVarntId
          )
          ?.map((cl) => {
            return cl?.detailId;
          });
        const prevAdmIds = procedValues?.adminList
          ?.filter(
            (al) =>
              al?.serviceId === selectedProcedure?.prevServId &&
              al?.variantId === selectedProcedure?.prevVarntId
          )
          ?.map((al) => {
            return al?.detailId;
          });
        // for deleting the prev
        deleteMultipleDetailIds([
          ...(prevCosumIds ?? []),
          ...(prevAdmIds ?? []),
        ]);
        const procedureDetails = getProcedureDetails(
          selectedProcedure?.serviceId ?? selectedProcedure?.service?.serviceId,
          selectedProcedure?.variantId ?? selectedProcedure?.variant?.variantId,
          selectedProcedure?.service?.name,
          services?.data ?? [],
          clinicStocks?.data ?? [],
          clinicDet?.pharmacyTaxId
        )?.procedureDetails;
        if (
          getProcedureDetails(
            selectedProcedure?.serviceId ??
              selectedProcedure?.service?.serviceId,
            selectedProcedure?.variantId ??
              selectedProcedure?.variant?.variantId,
            selectedProcedure?.service?.name,
            services?.data ?? [],
            clinicStocks?.data ?? [],
            clinicDet?.pharmacyTaxId
          )?.prescriptions?.length > 0
        ) {
          const data = {
            status: "Pending",
            remark: "",
            prescription: getProcedureDetails(
              selectedProcedure?.serviceId ??
                selectedProcedure?.service?.serviceId,
              selectedProcedure?.variantId ??
                selectedProcedure?.variant?.variantId,
              selectedProcedure?.service?.name,
              services?.data ?? [],
              clinicStocks?.data ?? [],
              clinicDet?.pharmacyTaxId
            )?.prescriptions,
            issue: "",
          };
          if (reqDet?.prescription?.[0]?.prescriptionId) {
            dispatch(
              updatePrescriptionByIdWoLoader({
                prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
                data,
              })
            );
          } else {
            dispatch(
              createPrescriptionWoLoader({
                appointmentId: appDet?.appointmentId,
                data,
              })
            );
          }
        }
        const data = {
          procedureName: selectedProcedure?.service?.name,
          serviceId: selectedProcedure?.service?.serviceId,
          category: selectedProcedure?.service?.category,
          subCategory: selectedProcedure?.service?.subCategory,
          remarks: selectedProcedure?.service?.remarks,
          doneAt: moment(new Date()).format("YYYY-MM-DD"),
          status: "Pending",
          petId: appDet?.petId,
          appointmentId: appDet?.appointmentId,
          serviceCharge: selectedProcedure?.variant?.serviceCharge,
          serviceType: getOnlyName(selectedProcedure?.variant?.name),
          procedureDetails,
        };
        dispatch(
          updateProcedureByIdWoLoader({
            id:
              selectedProcedure?.procedureId ??
              selectedProcedure?.service?.procedureId,
            data,
          })
        ).then((res) => {
          if (res?.payload) {
            onApiCall();
            onCloseChangeWarnMod();
          }
        });
      } else {
        if (
          selectedProcedure?.procedureId ??
          selectedProcedure?.service?.procedureId
        ) {
          dispatch(
            deleteProcedureByIdWoLoader(
              selectedProcedure?.procedureId ??
                selectedProcedure?.service?.procedureId
            )
          );
        }
        const procedureDetails = getProcedureDetails(
          selectedProcedure?.serviceId ?? selectedProcedure?.service?.serviceId,
          selectedProcedure?.variantId ?? selectedProcedure?.variant?.variantId,
          selectedProcedure?.service?.name,
          services?.data ?? [],
          clinicStocks?.data ?? [],
          clinicDet?.pharmacyTaxId
        )?.procedureDetails;
        if (
          getProcedureDetails(
            selectedProcedure?.serviceId ??
              selectedProcedure?.service?.serviceId,
            selectedProcedure?.variantId ??
              selectedProcedure?.variant?.variantId,
            selectedProcedure?.service?.name,
            services?.data ?? [],
            clinicStocks?.data ?? [],
            clinicDet?.pharmacyTaxId
          )?.prescriptions?.length > 0
        ) {
          const data = {
            status: "Pending",
            remark: "",
            prescription: getProcedureDetails(
              selectedProcedure?.serviceId ??
                selectedProcedure?.service?.serviceId,
              selectedProcedure?.variantId ??
                selectedProcedure?.variant?.variantId,
              selectedProcedure?.service?.name,
              services?.data ?? [],
              clinicStocks?.data ?? [],
              clinicDet?.pharmacyTaxId
            )?.prescriptions,
            issue: "",
          };
          if (reqDet?.prescription?.[0]?.prescriptionId) {
            dispatch(
              updatePrescriptionByIdWoLoader({
                prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
                data,
              })
            );
          } else {
            dispatch(
              createPrescriptionWoLoader({
                appointmentId: appDet?.appointmentId,
                data,
              })
            );
          }
        }
        const data = {
          procedureName: selectedProcedure?.service?.name,
          serviceId: selectedProcedure?.service?.serviceId,
          category: selectedProcedure?.service?.category,
          subCategory: selectedProcedure?.service?.subCategory,
          remarks: selectedProcedure?.service?.remarks,
          doneAt: moment(new Date()).format("YYYY-MM-DD"),
          status: "Pending",
          petId: appDet?.petId,
          appointmentId: appDet?.appointmentId,
          serviceCharge: selectedProcedure?.variant?.serviceCharge,
          serviceType: getOnlyName(selectedProcedure?.variant?.name),
          procedureDetails,
        };
        dispatch(createProcedureWoLoader(data)).then((res) => {
          if (res?.payload) {
            onApiCall();
            onCloseChangeWarnMod();
          }
        });
      }
    }
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedItem(null);
  };

  const onConfirmDelete = () => {
    if (selectedItem?.type === "procedureDetail") {
      deleteProcedureDetailById(selectedItem?.item?.detailId);
    }
    if (selectedItem?.type === "presDetail") {
      deletePresDetailById(selectedItem?.item?.detailId);
    }
  };

  return (
    <>
      <div className="mb20">
        {/* <div className="flex-row mh10 mt20">
          <div className="w25Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Procedure Name
            </Typography>
          </div>
          <div className="w25Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Variant
            </Typography>
          </div>
          <div className="w15Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Category
            </Typography>
          </div>
          <div className="w15Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Sub-Category
            </Typography>
          </div>
          <div className="w10Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Service Charge
            </Typography>
          </div>
          <div className="w10Per" />
        </div>
        <div className="blue-hor-split mt5" />
        {procedures?.map((prcd, index) => {
          return (
            <div
              className="flex-row mt10 plan-bor"
              key={`procedure_${prcd?.procedureId ?? index}`}
            >
              <div className="w25Per pr10">
                <CustomSelect
                  list={getServiceList()}
                  value={prcd?.service?.name}
                  handleChange={(value) => onChange("service", value, prcd?.i)}
                  error={prcd?.servErr}
                  helperText={prcd?.servErr ? reqTxt : ""}
                  addNewSelect
                  searchOnly
                  disabled={!prcd?.editable}
                />
              </div>
              <div className="w25Per pr10">
                <CustomSelect
                  list={getVarinatList(prcd?.service?.serviceId)}
                  value={prcd?.variant?.name}
                  select
                  handleChange={(e) => {
                    onChange(
                      "variant",
                      getVarinatList(prcd?.service?.serviceId)?.find(
                        (li) => li?.name === e?.target?.value
                      ),
                      prcd?.i,
                      prcd?.variantId
                    );
                  }}
                  error={prcd?.varErr}
                  helperText={prcd?.varErr ? reqTxt : ""}
                  disabled={!prcd?.editable}
                />
              </div>
              <div className="w15Per pr10">
                <Custom3dotString
                  str={prcd?.service?.category}
                  className="font-medium fs12 mt10"
                  length={13}
                />
              </div>
              <div className="w15Per pr10">
                <Custom3dotString
                  str={prcd?.service?.subCategory}
                  className="font-medium fs12 mt10"
                  length={13}
                />
              </div>
              <div className="w10Per">
                <Typography className="font-medium fs12 mt10">
                  Rs. {Number(prcd?.variant?.servicePrice ?? 0)?.toFixed(2)}
                </Typography>
              </div>
              <div className="w10Per">
                {appDet?.checkOut !== "Y" ? (
                  <div className="flex1-end mt3">
                    <div className="flex-row-ali-cen">
                      {prcd?.editable ? (
                        <div
                          className="cursor"
                          onClick={() => createUpdateProcedure(prcd)}
                        >
                          <div className="flex-center">
                            <SaveIcon sx={edtBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            Save
                          </Typography>
                        </div>
                      ) : null}
                      {!prcd?.editable ? (
                        <div
                          className="cursor ml10"
                          onClick={() => delProcedure(prcd?.i)}
                        >
                          <div className="flex-center">
                            <DeleteOutlineIcon sx={delBtn} />
                          </div>
                          <Typography className="red3 fs8 txt-semi-bold text-align-center">
                            Delete
                          </Typography>
                        </div>
                      ) : null}
                      {!prcd?.editable && (
                        <div
                          className="cursor ml10"
                          onClick={() => handleEditProcedure(prcd?.i)}
                        >
                          <div className="flex-center">
                            <EditIcon sx={edtBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            Edit
                          </Typography>
                        </div>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          );
        })}
        {appDet?.checkOut !== "Y" ? (
          <div className="flex-row-ali-cen mt10 cursor" onClick={addProcedure}>
            <div className="flex-center plus-icon">
              <AddIcon sx={addIcon} />
            </div>
            <Typography className="blue-color fs16 ml5 font-bold">
              Add
            </Typography>
          </div>
        ) : null} */}
        {procedures?.length > 0 ? (
          <>
            <Card sx={cardSty} className="mt20">
              <div
                className="flex-row-ali-cen cursor"
                onClick={() => handleObjOpen("consum", !objOpen?.consum)}
              >
                {objOpen?.consum ? (
                  <ArrowDropDownIcon sx={cardIcon} />
                ) : (
                  <ArrowRightIcon sx={cardIcon} />
                )}
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Consumables
                  </Typography>
                </div>
              </div>
              {objOpen?.consum ? (
                <div className="flex-column">
                  <div className="flex-row-ali-cen mh10">
                    <div className="w25Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Name
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Batch Number
                      </Typography>
                    </div>
                    <div className="w10Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Quantity
                      </Typography>
                    </div>
                    <div className="w15Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Status
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Reason
                      </Typography>
                    </div>
                    <div className="w10Per" />
                  </div>
                  <div className="blue-hor-split mt5" />
                  {procedValues?.consumList
                    ?.filter((li) => !li?.isDelete)
                    ?.map((li, i) => {
                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={`${li?.i}_consum`}
                        >
                          <div className="w25Per pr10">
                            <CustomSelect
                              list={
                                li?.fromService
                                  ? getDropList(li)
                                  : getList(false)
                              }
                              value={li?.name}
                              addNewSelect
                              searchOnly
                              handleChange={(e) => {
                                onChangeConsumValue(
                                  "name",
                                  e?.value ?? e,
                                  li?.i,
                                  {
                                    stockId: e?.stockId ?? null,
                                    productId: e?.productId ?? null,
                                    serviceId: e?.serviceId ?? null,
                                    type: e?.type,
                                  }
                                );
                              }}
                              plusBtn
                              disabled={!li?.isEdit}
                            />
                          </div>
                          <div className="w20Per pr10">
                            <CustomSelect
                              list={getBatches(li?.stockId)}
                              value={li?.batchNumber}
                              handleChange={(e, value) => {
                                onChangeConsumValue(
                                  "batchNumber",
                                  value,
                                  li?.i
                                );
                              }}
                              name="batchNumber"
                              search
                              isBatchNumber
                              disabled={!li?.isEdit}
                            />
                          </div>
                          <div className="w10Per pr10">
                            <CustomTextField
                              value={li?.quantity}
                              type="number"
                              fullWidth
                              handleChange={(e) =>
                                onChangeConsumValue(
                                  "quantity",
                                  e?.target?.value,
                                  li?.i
                                )
                              }
                              disabled={!li?.isEdit}
                            />
                          </div>
                          {/* <div className="w20Per pr10">
                            <CustomSelect
                              list={getProcedureListAsDrop()}
                              value={li?.linkToProcedure}
                              select
                              handleChange={(e) => {
                                const reqPrcd = getProcedureListAsDrop()?.find(
                                  (li) => li?.name === e?.target?.value
                                );
                                onChangeConsumValue(
                                  "linkToProcedure",
                                  e?.target?.value,
                                  li?.i,
                                  {
                                    serviceId: reqPrcd?.serviceId,
                                    variantId: reqPrcd?.variantId,
                                  }
                                );
                              }}
                              disabled={!li?.deleteable || !li?.isEdit}
                            />
                          </div> */}
                          <div className="w15Per pr10 mt10">
                            {li?.isRejected ||
                            li?.isRequested ||
                            li?.itemIssued ? (
                              <Typography
                                className={`${
                                  li?.itemIssued
                                    ? "green-back5"
                                    : li?.isRequested
                                    ? "orange-back2"
                                    : "red-back2"
                                } white-color status-con fs12 font-medium con-fit`}
                              >
                                {li?.itemIssued
                                  ? "Issued"
                                  : li?.isRequested
                                  ? "Requested"
                                  : "Rejected"}
                              </Typography>
                            ) : null}
                          </div>
                          <div className="w20Per pr10">
                            {typeof li?.itemIssued === "boolean" ? (
                              <div className="mt10 black2 txt-regular fs12">
                                {li?.reason}
                              </div>
                            ) : null}
                          </div>
                          <div className="w10Per mt5">
                            {appDet?.checkOut !== "Y" ? (
                              <div className="flex-row-ali-cen">
                                {/* {li?.isEdit ? (
                              <div
                                className="cursor"
                                onClick={() => addUpdateConsumItems(li)}
                              >
                                <div className="flex-center">
                                  <SaveIcon sx={edtBtn} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  Save
                                </Typography>
                              </div>
                            ) : null} */}
                                {li?.isEdit ? (
                                  <div className="flex-row-ali-cen mt5">
                                    <img
                                      src={require("../../../../assets/images/png/tick.png")}
                                      className="img-wh20 cursor"
                                      onClick={() =>
                                        onChangeConsumValue(
                                          "itemIssued",
                                          true,
                                          li?.i
                                        )
                                      }
                                    />
                                    <img
                                      src={require("../../../../assets/images/png/crossRed.png")}
                                      className="img-wh20 ml10 cursor"
                                      onClick={() =>
                                        onChangeConsumValue(
                                          "itemIssued",
                                          null,
                                          li?.i
                                        )
                                      }
                                    />
                                  </div>
                                ) : li?.deleteable && !li?.isEdit ? (
                                  <div
                                    className="cursor"
                                    onClick={() => handleConsumDelete(li?.i)}
                                  >
                                    <div className="flex-center">
                                      <DeleteOutlineIcon sx={delBtn} />
                                    </div>
                                    <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                      Delete
                                    </Typography>
                                  </div>
                                ) : null}
                                {!li?.isEdit ? (
                                  <div
                                    className="cursor ml10"
                                    onClick={() => handleConsumEdit(li?.i)}
                                  >
                                    <div className="flex-center">
                                      <EditIcon sx={edtBtn} />
                                    </div>
                                    <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                      Edit
                                    </Typography>
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      );
                    })}
                  {appDet?.checkOut !== "Y" ? (
                    <div className="flex-row-ali-cen mt20">
                      <div
                        className="flex-row-ali-cen cursor"
                        onClick={addNewConsumable}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={addIcon} />
                        </div>
                        <Typography className="blue-color fs16 ml5 font-bold">
                          Add
                        </Typography>
                      </div>
                      {/* <div
                        className="flex-row-ali-cen cursor ml20"
                        onClick={() => onAddFiles("consumables")}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={addIcon} />
                        </div>
                        <Typography className="blue-color fs16 ml5 font-bold">
                          Add From File
                        </Typography>
                      </div> */}
                    </div>
                  ) : null}
                </div>
              ) : null}
            </Card>

            <Card sx={cardSty} className="mt20">
              <div
                className="flex-row-ali-cen cursor"
                onClick={() => handleObjOpen("admin", !objOpen?.admin)}
              >
                {objOpen?.admin ? (
                  <ArrowDropDownIcon sx={cardIcon} />
                ) : (
                  <ArrowRightIcon sx={cardIcon} />
                )}
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Administer
                  </Typography>
                </div>
              </div>
              {objOpen?.admin ? (
                <div className="flex-column">
                  <div className="flex-row-ali-cen mh10">
                    <div className="w25Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Name
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Batch Number
                      </Typography>
                    </div>
                    <div className="w15Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Dosage
                      </Typography>
                    </div>
                    <div className="w15Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Route
                      </Typography>
                    </div>
                    {/* <div className="w15Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Link to Procedure
                      </Typography>
                    </div> */}
                    <div className="w15Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Status
                      </Typography>
                    </div>
                    <div className="w10Per" />
                  </div>
                  <div className="blue-hor-split mt5" />
                  {procedValues?.adminList
                    ?.filter((li) => !li?.isDelete)
                    ?.map((li, i) => {
                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={`${i}_admin`}
                        >
                          <div className="w25Per pr10">
                            <CustomSelect
                              list={
                                li?.fromService
                                  ? getDropList(li)
                                  : getList(true)
                              }
                              value={li?.name}
                              addNewSelect
                              mandatoryField
                              handleChange={(e) => {
                                onChangeAdminValue(
                                  "name",
                                  e?.value ?? e,
                                  li?.i,
                                  {
                                    stockId: e?.stockId ?? null,
                                    productId: e?.productId ?? null,
                                    serviceId: e?.serviceId ?? null,
                                    type: e?.type,
                                  }
                                );
                              }}
                              plusBtn
                              disabled={!li?.isEdit}
                            />
                          </div>
                          <div className="w20Per pr10">
                            <CustomSelect
                              list={getBatches(li?.stockId)}
                              value={li?.batchNumber}
                              handleChange={(e, value) => {
                                onChangeAdminValue("batchNumber", value, li?.i);
                              }}
                              search
                              disabled={!li?.isEdit}
                              isBatchNumber
                            />
                          </div>
                          <div className="w15Per pr10">
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onChangeAdminValue(
                                  "dosage",
                                  e?.target?.value,
                                  li?.i
                                )
                              }
                              value={li?.dosage}
                              suffix={
                                getRightPackageUom(
                                  getBatch(
                                    li?.stockId,
                                    li?.batchNumber?.value ?? li?.batchId
                                  )?.packageUom
                                )?.length > 0 ? (
                                  <Custom3dotString
                                    str={`${getRightPackageUom(
                                      getBatch(
                                        li?.stockId,
                                        li?.batchNumber?.value ?? li?.batchId
                                      )?.packageUom
                                    )}`}
                                    className="fs12 font-medium"
                                  />
                                ) : (
                                  ""
                                )
                              }
                              type="number"
                              disabled={!li?.isEdit}
                            />
                          </div>
                          <div className="w15Per pr10">
                            <CustomSelect
                              list={routeList}
                              value={li?.route}
                              search
                              handleChange={(e, value) => {
                                onChangeAdminValue("route", value, li?.i);
                              }}
                              disabled={!li?.isEdit}
                            />
                          </div>
                          {/* <div className="w15Per pr10">
                            <CustomSelect
                              list={getProcedureListAsDrop()}
                              value={li?.linkToProcedure}
                              select
                              handleChange={(e) => {
                                const reqPrcd = getProcedureListAsDrop()?.find(
                                  (li) => li?.name === e?.target?.value
                                );
                                onChangeAdminValue(
                                  "linkToProcedure",
                                  e?.target?.value,
                                  li?.i,
                                  {
                                    serviceId: reqPrcd?.serviceId,
                                    variantId: reqPrcd?.variantId,
                                  }
                                );
                              }}
                              disabled={!li?.deleteable || !li?.isEdit}
                            />
                          </div> */}
                          <div className="w15Per pr10 mt10">
                            {li?.isRejected ||
                            li?.isRequested ||
                            li?.itemIssued ? (
                              <Typography
                                className={`${
                                  li?.itemIssued
                                    ? "green-back5"
                                    : li?.isRequested
                                    ? "orange-back2"
                                    : "red-back2"
                                } white-color status-con fs12 font-medium con-fit`}
                              >
                                {li?.itemIssued
                                  ? "Issued"
                                  : li?.isRequested
                                  ? "Requested"
                                  : "Rejected"}
                              </Typography>
                            ) : null}
                          </div>
                          <div className="w10Per mt5">
                            {appDet?.checkOut !== "Y" ? (
                              <div className="flex-row-ali-cen">
                                {li?.isEdit ? (
                                  <div className="flex-row-ali-cen">
                                    <img
                                      src={require("../../../../assets/images/png/tick.png")}
                                      className="img-wh20 cursor"
                                      onClick={() =>
                                        onChangeAdminValue(
                                          "itemIssued",
                                          true,
                                          li?.i
                                        )
                                      }
                                    />
                                    <img
                                      src={require("../../../../assets/images/png/crossRed.png")}
                                      className="img-wh20 ml10 cursor"
                                      onClick={() =>
                                        onChangeAdminValue(
                                          "itemIssued",
                                          null,
                                          li?.i
                                        )
                                      }
                                    />
                                  </div>
                                ) : li?.deleteable && !li?.isEdit ? (
                                  <div
                                    className="cursor"
                                    onClick={() => handleAdminDelete(li?.i)}
                                  >
                                    <div className="flex-center">
                                      <DeleteOutlineIcon sx={delBtn} />
                                    </div>
                                    <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                      Delete
                                    </Typography>
                                  </div>
                                ) : null}
                                {!li?.isEdit ? (
                                  <div
                                    className="cursor ml10"
                                    onClick={() => handleAdminEdit(li?.i)}
                                  >
                                    <div className="flex-center">
                                      <EditIcon sx={edtBtn} />
                                    </div>
                                    <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                      Edit
                                    </Typography>
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      );
                    })}
                  {appDet?.checkOut !== "Y" ? (
                    <div className="flex-row-ali-cen mt20">
                      <div
                        className="flex-row-ali-cen cursor"
                        onClick={addNewAdminister}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={addIcon} />
                        </div>
                        <Typography className="blue-color fs16 ml5 font-bold">
                          Add
                        </Typography>
                      </div>
                      {/* <div
                        className="flex-row-ali-cen cursor ml20"
                        onClick={() => onAddFiles("administer")}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={addIcon} />
                        </div>
                        <Typography className="blue-color fs16 ml5 font-bold">
                          Add From File
                        </Typography>
                      </div> */}
                    </div>
                  ) : null}
                </div>
              ) : null}
            </Card>
          </>
        ) : null}

        <Card sx={cardSty} className="mt20">
          <div
            className="flex-row-ali-cen cursor"
            onClick={() => handleObjOpen("pres", !objOpen?.pres)}
          >
            {objOpen?.pres ? (
              <ArrowDropDownIcon sx={cardIcon} />
            ) : (
              <ArrowRightIcon sx={cardIcon} />
            )}
            <Typography className="font-bold fs14 blue-color">
              Prescription
            </Typography>
          </div>
          {objOpen?.pres ? (
            <div style={{ overflowX: "auto", width: "100%" }} className="pb10">
              <div style={{ minWidth: 1310 }}>
                <div className="flex-row-ali-cen mh10">
                  <div style={{ width: 200 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Name <span className="red-color">*</span>
                    </Typography>
                  </div>
                  <div style={{ width: 170 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Qty <span className="red-color">*</span>
                    </Typography>
                  </div>
                  <div style={{ width: 170 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Dosage
                    </Typography>
                  </div>
                  <div style={{ width: 170 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Duration
                    </Typography>
                  </div>
                  <div style={{ width: 150 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Frequency
                    </Typography>
                  </div>
                  <div style={{ width: 150 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Instructions
                    </Typography>
                  </div>
                  <div style={{ width: 200 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Remarks
                    </Typography>
                  </div>
                  {/* <div style={{ width: 100 }} /> */}
                </div>
                <div className="blue-hor-split mt5" />
                {procedValues?.presList?.map((pr, ind) => {
                  return (
                    <div className="flex-row mt10 plan-bor" key={`${ind}_pres`}>
                      <div className="pr10" style={{ width: 200 }}>
                        <CustomSelect
                          list={getPresList()}
                          value={pr?.plName}
                          error={pr?.nameErr}
                          helperText={pr?.nameErr ? reqTxt : ""}
                          addNewSelect
                          mandatoryField
                          handleChange={(e) => {
                            handleChangePresValue(
                              "plName",
                              e?.value ?? e,
                              pr?.i,
                              {
                                stockId: e?.stockId ?? null,
                                productId: e?.productId ?? null,
                                serviceId: e?.serviceId ?? null,
                                type: e?.type,
                              }
                            );
                          }}
                          plusBtn
                          disabled
                          // ={!pr?.isEdit}
                        />
                      </div>
                      <div className="pr10" style={{ width: 170 }}>
                        <CustomTextField
                          value={pr?.qty}
                          error={pr?.qtyErr}
                          helperText={pr?.qtyErr ? reqTxt : ""}
                          handleChange={(e) => {
                            handleChangePresValue(
                              "qty",
                              e?.target?.value,
                              pr?.i
                            );
                          }}
                          fullWidth
                          type="number"
                          endIcon
                          inputIcon={
                            getBatchList(pr?.stockId)?.[0]?.salesUom ?? ""
                          }
                          disabled
                          // ={!pr?.isEdit}
                        />
                      </div>
                      <div className="pr10" style={{ width: 170 }}>
                        <CustomTextField
                          fullWidth
                          handleChange={(e) =>
                            handleChangePresValue(
                              "dosage",
                              e?.target?.value,
                              pr?.i
                            )
                          }
                          value={pr?.dosage}
                          disabled
                          // ={!pr?.isEdit}
                          suffix={
                            getRightPackageUom(
                              getBatchList(pr?.stockId)?.[0]?.packageUom
                            )?.length > 0 ? (
                              <Custom3dotString
                                str={`${getRightPackageUom(
                                  getBatchList(pr?.stockId)?.[0]?.packageUom
                                )}`}
                                className="fs12 font-medium"
                              />
                            ) : (
                              ""
                            )
                          }
                        />
                      </div>
                      <div className="pr10" style={{ width: 170 }}>
                        <CustomTextField
                          fullWidth
                          handleChange={(e) =>
                            handleChangePresValue(
                              "duration",
                              e?.target?.value,
                              pr?.i
                            )
                          }
                          value={pr?.duration}
                          endIcon
                          inputIcon="days"
                          disabled
                          // ={!pr?.isEdit}
                        />
                      </div>
                      <div className="pr10" style={{ width: 150 }}>
                        {pr?.customFrequency ? (
                          <CustomTextField
                            fullWidth
                            handleChange={(e) =>
                              handleChangePresValue(
                                "frequency",
                                e?.target?.value,
                                pr?.i
                              )
                            }
                            value={pr?.frequency}
                            disabled
                            // ={!pr?.isEdit}
                          />
                        ) : (
                          <CustomSelect
                            list={frequncyCheckList}
                            value={pr?.frequency ?? []}
                            handleChange={(e) => {
                              handleChangePresValue(
                                "frequency",
                                e?.target?.value,
                                pr?.i
                              );
                            }}
                            multiSelectTagCheck
                            disabled
                            // ={!pr?.isEdit}
                          />
                        )}
                      </div>
                      <div className="pr10" style={{ width: 150 }}>
                        <CustomSelect
                          list={mealTypes}
                          value={pr?.meal}
                          select
                          handleChange={(e) => {
                            handleChangePresValue(
                              "meal",
                              e?.target?.value,
                              pr?.i
                            );
                          }}
                          disabled
                          // ={!pr?.isEdit}
                        />
                      </div>
                      <div className="pr10" style={{ width: 200 }}>
                        <CustomTextField
                          value={pr?.remark}
                          handleChange={(e) => {
                            handleChangePresValue(
                              "remark",
                              e?.target?.value,
                              pr?.i
                            );
                          }}
                          disabled
                          // ={!pr?.isEdit}
                          fullWidth
                        />
                      </div>
                      {/* <div className="flex-end" style={{ width: 100 }}>
                        {appDet?.checkOut !== "Y" ? (
                          <div className="flex-row-ali-cen mt3">
                            <div
                              className="cursor"
                              onClick={() => deletePresByIndex(pr?.i)}
                            >
                              <div className="flex-center">
                                <DeleteOutlineIcon sx={delBtn} />
                              </div>
                              <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                Delete
                              </Typography>
                            </div>

                            {pr?.isEdit ? (
                              <div
                                className="cursor ml10"
                                onClick={() => addUpdatePresItems(pr)}
                              >
                                <div className="flex-center">
                                  <SaveIcon sx={edtBtn} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  Save
                                </Typography>
                              </div>
                            ) : null}

                            {!pr?.isEdit ? (
                              <div
                                className="cursor ml10"
                                onClick={() => handleEditPresItem(pr?.i)}
                              >
                                <div className="flex-center">
                                  <EditIcon sx={edtBtn} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  Edit
                                </Typography>
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                      </div> */}
                    </div>
                  );
                })}
              </div>
              {appDet?.checkOut !== "Y" ? (
                <div className="flex-row-ali-cen mt20">
                  <div
                    className="flex-row-ali-cen cursor"
                    onClick={handleAddNewPres}
                  >
                    <div className="flex-center plus-icon">
                      <AddIcon sx={addIcon} />
                    </div>
                    <Typography className="blue-color fs16 ml5 font-bold">
                      Add
                    </Typography>
                  </div>
                  {/* <div
                    className="flex-row-ali-cen cursor ml20"
                    onClick={() => onAddFiles("pres")}
                  >
                    <div className="flex-center plus-icon">
                      <AddIcon sx={addIcon} />
                    </div>
                    <Typography className="blue-color fs16 ml5 font-bold">
                      Add From File
                    </Typography>
                  </div> */}
                </div>
              ) : null}
            </div>
          ) : null}
        </Card>
        {/* <div className="mt20 flex-row-ali-cen">
          <Typography className="font-bold fs14 blue-color">Notes</Typography>
          {appDet?.checkOut !== "Y" ? (
            <div
              className="flex-row-ali-cen cursor flex1-end"
              onClick={onAddNotes}
            >
              <div className="flex-center plus-icon">
                <AddIcon sx={addIcon} />
              </div>
              <Typography className="blue-color fs16 ml5 font-bold">
                Add
              </Typography>
            </div>
          ) : null}
        </div>
        <Typography className="mt5 mb10 font-medium fs12 black">
          {appDet?.notes}
        </Typography> */}
      </div>

      <CustomModal
        open={conStatusVsble}
        onClose={onCloseConMod}
        header="Reason"
        modal
        modalWidth={30}
        headerShown={true}
      >
        <div className="ph10">
          <CustomSelect
            list={reasonIssueList}
            value={consumValues?.itemIssuedStatus}
            select
            handleChange={(e) =>
              onChangeConStatusValue("itemIssuedStatus", e?.target?.value)
            }
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton
              text="Save"
              smallBtn
              onClick={handleSaveConsumStatus}
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={admStatusVsble}
        onClose={onCloseAdmMod}
        header="Reason"
        modal
        modalWidth={30}
        headerShown={true}
      >
        <div className="ph10">
          <CustomSelect
            list={reasonIssueList}
            value={adminValues?.itemIssuedStatus}
            select
            handleChange={(e) =>
              onChangeAdminStatusValue("itemIssuedStatus", e?.target?.value)
            }
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton
              text="Save"
              smallBtn
              onClick={handleSaveAdminStatus}
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={presStatusVsble}
        onClose={onClosePresMod}
        header="Reason"
        modal
        modalWidth={30}
        headerShown={true}
      >
        <div className="ph10">
          <CustomSelect
            list={reasonIssueList}
            value={presValues?.itemIssuedStatus}
            select
            handleChange={(e) =>
              onChangePresStatusValue("itemIssuedStatus", e?.target?.value)
            }
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton text="Save" smallBtn onClick={handleSavePresStatus} />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={notesModVsble}
        onClose={onCloseNoteMod}
        header="Notes"
        modal
        modalWidth={40}
        headerShown={true}
      >
        <div className="ph10">
          <CustomTextField
            value={notes}
            handleChange={(e) => setNotes(e?.target?.value)}
            multiline
            fullWidth
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton text="Save" smallBtn onClick={onSaveNotes} />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={admUpdteModVsble}
        onClose={onCloseAdmUpdteMod}
        header="Administer"
        rightModal
        modalWidth={30}
      >
        <div className="ph20 scroll-80vh">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Name</div>
              <CustomSelect
                list={
                  adminValues?.fromService
                    ? getDropList(adminValues)
                    : getList(true)
                }
                value={adminValues?.name}
                addNewSelect
                mandatoryField
                handleChange={(e) => {
                  onChangeAdminModValue("name", e?.value ?? e, {
                    stockId: e?.stockId ?? null,
                    productId: e?.productId ?? null,
                    serviceId: e?.serviceId ?? null,
                    type: e?.type,
                  });
                }}
                plusBtn
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Batch Number</div>
              <CustomSelect
                list={getBatches(adminValues?.stockId)}
                value={adminValues?.batchNumber}
                handleChange={(e, value) => {
                  onChangeAdminModValue("batchNumber", value);
                }}
                search
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Dosage</div>
              <CustomTextField
                fullWidth
                handleChange={(e) =>
                  onChangeAdminModValue("dosage", e?.target?.value)
                }
                value={adminValues?.dosage}
                suffix={
                  getRightPackageUom(
                    getBatch(
                      adminValues?.stockId,
                      adminValues?.batchNumber?.value ?? adminValues?.batchId
                    )?.packageUom
                  )?.length > 0 ? (
                    <Custom3dotString
                      str={`${getRightPackageUom(
                        getBatch(
                          adminValues?.stockId,
                          adminValues?.batchNumber?.value ??
                            adminValues?.batchId
                        )?.packageUom
                      )}`}
                      className="fs12 font-medium"
                    />
                  ) : (
                    ""
                  )
                }
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Route</div>
              <CustomSelect
                list={routeList}
                value={adminValues?.route}
                search
                handleChange={(e, value) => {
                  onChangeAdminModValue("route", value);
                }}
              />
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Link to Procedure
              </div>
              <CustomSelect
                list={getProcedureListAsDrop()}
                value={adminValues?.linkToProcedure}
                select
                handleChange={(e) => {
                  const reqPrcd = getProcedureListAsDrop()?.find(
                    (li) => li?.name === e?.target?.value
                  );
                  onChangeAdminModValue("linkToProcedure", e?.target?.value, {
                    serviceId: reqPrcd?.serviceId,
                    variantId: reqPrcd?.variantId,
                  });
                }}
              />
            </Grid> */}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <div className="txt-semi-bold fs14 light-grey">Status </div>
                {typeof adminValues?.itemIssued === "boolean" ? (
                  <Typography
                    className={`${
                      adminValues?.itemIssued ? "green-back5" : "red-back2"
                    } white-color status-con fs12 font-medium ml15`}
                  >
                    {adminValues?.itemIssued ? "Issued" : "Rejected"}
                  </Typography>
                ) : null}
              </div>
              <div className="mt5">
                <CustomSelect
                  list={pharmacyStatusDrop}
                  value={adminValues?.itemIssued}
                  select
                  handleChange={(e) =>
                    onChangeAdminModValue("itemIssued", e?.target?.value)
                  }
                />
              </div>
            </Grid>
            {typeof adminValues?.itemIssued === "boolean" &&
            !adminValues?.itemIssued ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 light-grey">Reason</div>
                <CustomSelect
                  list={reasonIssueList}
                  value={adminValues?.itemIssuedStatus}
                  select
                  handleChange={(e) =>
                    onChangeAdminModValue("itemIssuedStatus", e?.target?.value)
                  }
                />
              </Grid>
            ) : null}
          </Grid>

          <div className="flex-center">
            <div className="w20Per mv20">
              <CustomButton text="Save" smallBtn onClick={onSaveAdminValues} />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={fileValues?.modVsble}
        onClose={onCloseFileMod}
        header="Files"
        modal
        modalWidth={40}
      >
        <div className="ph20 scroll-50vh">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {fileValues?.files?.length > 0 ? (
                <FilesWithCloseButton
                  files={fileValues?.files}
                  onClickFile={(i, file) => handleRemoveFile(i)}
                />
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomUpload
                onUploadFile={onUploadFiles}
                multipleNew
                multiFiles
                fileAccept="image/*,.pdf"
              />
            </Grid>
          </Grid>

          <div className="flex-center">
            <div className="w20Per mv20">
              <CustomButton text="Upload" smallBtn onClick={onFilesApiCall} />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={changeWarnVsble}
        onClose={onCloseChangeWarnMod}
        header=""
        modal
        modalWidth={30}
        headerShown={false}
      >
        <div className="flex-row">
          <Typography className="txt-semi-bold fs16 text-align-center mv20 orange4">
            All changes will be lost. Are you sure you want to continue?
          </Typography>
        </div>
        <div className="flex-row-ali-cen flex-center pb20">
          <div>
            <CustomButton
              text="Yes"
              redBtn
              smallBtn
              onClick={onConfirmChangeWarn}
            />
          </div>
          <div className="ml20">
            <CustomButton text="No" smallBtn onClick={onCloseChangeWarnMod} />
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header=""
        modal
        modalWidth={30}
        headerShown={false}
      >
        <div className="flex-center">
          <Typography className="txt-semi-bold fs16 text-align-center mv20 orange4">
            Are you sure you want to delete this record?
          </Typography>
        </div>
        <div className="flex-row-ali-cen flex-center pb20">
          <div>
            <CustomButton
              text="Yes"
              redBtn
              smallBtn
              onClick={onConfirmDelete}
            />
          </div>
          <div className="ml20">
            <CustomButton text="No" smallBtn onClick={onCloseDelMod} />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default PetPharmacyProcedures;
